import react from "react";
import {useState,useRef } from "react";
import { FaHome , FaBoxOpen,FaInfoCircle , FaPhoneSquare} from 'react-icons/fa';
import logo from '../assets/LOGO.webp';
import Hero from "./hero";
import Boxes from "./boxes";
import Products from "./products";
import Footer from "./footer";
function Nav(){
    const BASE_URL = '/docs/A.pdf';
    const [isOpen, setIsOpen] = useState(false);
    const MainP = useRef(null);
    const productsP = useRef(null);
    const footerP = useRef(null);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const scrolltosection = (ref) => {
        closeMenu();
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
        <header dir="rtl" className="bg-[var(--header)] sticky top-0 w-full z-50 h-[100px] lg:h-[80px] shadow-md flex items-center justify-between px-4 lg:px-0 relative font-ibmArabic">
            <div className="flex-1 flex justify-center mx-auto lg:hidden">
                <img decoding="async" src={logo} alt="logo" className="w-[160px] h-[160px] md:w-[180px] md:h-[180px] lg:w-[280px] lg:h-[150px] overflow-hidden " />
            </div> 
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer z-50 lg:hidden">
                <button onClick={toggleMenu} className="text-3xl font-bold text-gray-600">☰</button>
            </div>
            <div className="hidden lg:flex items-center space-x-10">
                <img decoding="async" src={logo} alt="logo" className="w-[160px] h-[160px] overflow-hidden" />
                <nav className="flex items-center space-x-10 font-[Almarai]">
                    <ul className="flex space-x-6 font-ibmArabic">
                        <li className="relative group flex items-center ">
                            <button onClick={() => scrolltosection(MainP)} className="px-10 py-2 text-[20px] font-bold text-[var(--primary)] hover:text-[var(--primary-dark)] flex items-center">
                                الرئيسية <FaHome className="ml-2 mr-1" />
                            </button>
                        </li>
                        <li className="relative group flex items-center">
                            <button onClick={() => scrolltosection(productsP)} className="px-6 py-2 text-[20px] font-bold text-[var(--primary)] hover:text-[var(--primary-dark)] flex items-center">
                                منتجاتنا <FaBoxOpen className="ml-2 mr-1" />
                            </button>
                        </li>
                        <li>
                            <button onClick={() => scrolltosection(footerP)} className="flex items-center px-6 py-2 hover:text-[var(--primary-dark)] rounded text-[var(--primary)] font-bold text-[20px]">
                                تواصل معنا <FaPhoneSquare className="ml-2 mr-1"  />
                            </button>
                        </li>
                        <li className="relative group flex items-center">
                            <a href={BASE_URL} target="noreferrer" className="flex items-center text-[20px] px-6 py-2 font-bold text-[var(--primary)] hover:text-[var(--primary-dark)]">
                                عن مارة <FaInfoCircle className="ml-2 mr-1" />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>

        {/* mobile menu */}
        <div dir="rtl" className={`fixed top-0 right-0 h-full w-56 min-w-[14rem] bg-[var(--primary)] p-4 overflow-y-auto z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
            <button onClick={closeMenu} className="mb-6 text-xl font-bold text-[#fff]">× إغلاق</button>
            <ul className="space-y-4">
                <li>
                    <button onClick={() => scrolltosection(MainP)} className="flex items-center px-4 py-2 hover:bg-gray-100 rounded text-[#fff]">
                        الرئيسية <FaHome className="ml-2" />
                    </button>
                </li>
                <li>
                    <button onClick={() => scrolltosection(productsP)} className="flex items-center px-4 py-2 hover:bg-gray-100 rounded text-[#fff]">
                        منتجاتنا <FaBoxOpen className="ml-2" />
                    </button>
                </li>
                <li>
                    <button onClick={() => scrolltosection(footerP)} className="flex items-center px-4 py-2 hover:bg-gray-100 rounded text-[#fff]">
                        تواصل معنا <FaPhoneSquare className="ml-2" />
                    </button>
                </li>
                <li>
                    <a href={BASE_URL} target="noreferrer" className="flex items-center px-6 py-4 text-[#fff]">
                        عن مارة <FaInfoCircle className="ml-2" />
                    </a>
                </li>

            </ul>
        </div>

        <div ref={MainP} className="h-1000px "style={{
        }}>
            <Hero footerRef={footerP} /> 
            <Boxes/>
        </div>
        <div ref={productsP} className="h-screen "
                style={{
                background: "linear-gradient(135deg, #F0FFFF 0%, #E0F7FF 35%, #B3E9FF 70%, #7FD4FF 100%)", 
                margin: '0px',
            }}
        >
            <Products/>
        </div>
        <div ref={footerP} className="scroll-mt-[100px]">
            <Footer/>
        </div>
        </>
    );

}
export default Nav;